import Vue, { VueConstructor } from 'vue';
import axios, { AxiosRequestConfig, AxiosInstance } from 'axios';
import * as Common from '@/agiles/common';
import { words } from '@/agiles/common/words';
import VueRouter from 'vue-router';

// 開発協力値引対象機能の一覧
export enum customFunctionFlags 
{
    bCartGetOrder, //Bカート受注取り込み機能
    scanRegistration, //スキャン登録機能
}
// 機能開放フラグ　trueになっている機能はすべてのユーザーで利用可能になります。falseの場合は、テナントの機能開放フラグに従います。
const customFunctionFlagDefinitions: Record<customFunctionFlags, boolean> = {
  [customFunctionFlags.bCartGetOrder]: false, // Bカート受注取り込み機能開放フラグ
  [customFunctionFlags.scanRegistration]: false, // スキャン登録機能開放フラグ
};

// apiアクセスの管理〜apiに認証ヘッダ(トークン)を付与する必要があります。
export class Api {

  constructor() {
    //例外ハンドラのアタッチ
    axios.interceptors.request.use(
      config => {
        config.withCredentials = true;
        return config;
      },
      error => {
        this.modal.show('無効な操作', error, true, null);
        return Promise.reject(error);
      }
    );
 
    axios.interceptors.response.use(
      config => {
        return config;
      },
      error => {
        this.closeWaitCursor(true);
        
        //エラー画面でOKを押した時点でプロミスを返す仕様に変更(reject)
        return new Promise((resolve,reject) =>{
          if (error.response != null && error.response.status == 500) {
            var result = error.response.data;          
            if (result instanceof Blob){
                var reader = new FileReader();
                reader.onloadend = (evt) => {
                    var result = JSON.parse((evt.target as any).result as string);
                    const detail = this.errorBinder.loadInstance(result);
                    this.modal.show('無効な操作', detail.message, true, reject);                  
                };
                reader.readAsText(error.response.data);
            } else {
              const detail = this.errorBinder.loadInstance(result);
              if ((detail.message as string).indexOf('※サンプルデータの削除')>-1) reject(detail); //削除エラー=>ListViewで処理する
              else this.modal.show('無効な操作', detail.message, true, ()=>reject(error));
            }

          } else if (error.response != null && error.response.status == 401) {
            //mfaエクセプションの処理
            if (error.response.data.message == 'MfaException:initialize') this.handleMfaException(Common.mfaFlags.initialize);
            else if (error.response.data.message == 'MfaException:duplicate_session') this.handleMfaException(Common.mfaFlags.duplicate_session);
            else if (error.response.data.message == 'MfaException:send_sms') this.handleMfaException(Common.mfaFlags.send_sms);
            else if (error.response.data.message == 'MfaException:reset_confirm') this.handleMfaException(Common.mfaFlags.reset_confirm);
            else if (error.response.data.message == 'MfaException:reset_invalid') this.handleMfaException(Common.mfaFlags.reset_invalid);                      
            else this.modal.show('無効な操作', 'ユーザーが認証されていません', true, reject);

            return;
          } else if (error.response != null && error.response.status == 422) {
              if(location.href.includes('s-flow.net')) location.href=location.href.replace('s-flow.net','s-flow-prime.net');
              else if(location.href.includes('s-flow-prime.net')) location.href=location.href.replace('s-flow-prime.net','s-flow.net');
              else if(location.href.includes('trade-system.info')) location.href=location.href.replace('trade-system.info','code-x.co.jp');
              else if(location.href.includes('code-x.co.jp')) location.href=location.href.replace('code-x.co.jp','trade-system.info');
              else this.modal.show('無効な操作', 'アクセスできません。URLを確認してください。', true, reject);
          } else if (error.response != null && error.response.status == 403) {
            this.modal.show('無効な操作', 'アクセス許可がないためサインインできませんでした', true, ()=>this.auth.logout());          
          } else if (error.response != null && error.request.responseType === 'blob' && error.response.data instanceof Blob && error.response.data.type && error.response.data.type.toLowerCase().indexOf('json') != -1) {
            //responseType=blobの場合は、error.responseもaxiosがblobに変換してしまうので、再解凍する
            return new Promise((resolve, reject) => {
              let reader = new FileReader();
              reader.onload = () => resolve(reader.result);
              reader.onerror = () => reject(error);
              reader.readAsText(error.response.data);
            }).then(resposne => {
              var json = JSON.parse(resposne as string);
              this.modal.show('無効な操作', json.message, true, null);
              return Promise.reject(error);
            });
          } else if (error.message && error.message.match('timeout of [0-9]+ms exceeded')) {
            this.modal.show('', 'タイムアウトが発生しました。処理は継続されているため、時間をおいてから画面を更新してください', true, null);
          } else if (error.response != null && error.response.status == 504) {
            this.modal.show('無効な操作', 'タイムアウトが発生しました。繰返し発生する場合はサポートデスクまでご連絡ください。', true, null);               
          } else if (error.message && error.message == 'Network Error') {
            this.modal.show('無効な操作', "サービスに接続できませんでした", true, null);          
          } else if (error.message) {
            this.modal.show('無効な操作', error.message, true, null);
          } else {
            this.modal.show('無効な操作', error.response.data, true, null);
          }

        });        
        //return Promise.reject(error);
      }
    );
  }

  // private static tenantId = process.env.NODE_ENV == 'production' ? window.location.host.split('.')[0] : 'backlog-st';
  // private static baseURL = (process.env.NODE_ENV == 'production' ? process.env.VUE_APP_API : 'https://localhost:5003/') + Api.tenantId;
  //  private static baseURL = 'https://api.code-x.co.jp/backlog_st/' + Api.tenantId;

  public static get baseURL():string {
    //リリースビルドはsubdomain、デバッグビルドはVUE_APP_SUBDOMAINで判定します。    
    let subdomain = '';
    if (process.env.NODE_ENV == 'production'){
      subdomain = window.location.host.split('.')[0];      
    } else {
      subdomain =process.env.VUE_APP_SUBDOMAIN;
    }
    return process.env.VUE_APP_API  + subdomain;
  } 

  public static get tenantResetBaseURL():string {
    //リリースビルドはsubdomain、デバッグビルドはVUE_APP_SUBDOMAINで判定します。    
    let subdomain = '';
    if (process.env.NODE_ENV == 'production'){
      subdomain = window.location.host.split('.')[0];      
    } else {
      subdomain =process.env.VUE_APP_SUBDOMAIN;
    }
    return process.env.VUE_APP_RESET_API  + subdomain;
  } 
  public static get siteMode():Common.siteModes {
    //リリースビルドはsubdomain、デバッグビルドはVUE_APP_SUBDOMAINで判定します。
    let subdomain = '';
    if (process.env.NODE_ENV == 'production'){
      subdomain = window.location.host.split('.')[0];      
    } else {
      subdomain =process.env.VUE_APP_SUBDOMAIN;
    }

    if (subdomain=='admin') return Common.siteModes.admin;
    else if (subdomain == 'signup' || subdomain == 'contract') return Common.siteModes.signup;
    else return Common.siteModes.tenant;    
  }
  public get isProduction()  {return process.env.NODE_ENV == 'production';}
  public spMode:boolean = false;
  public innerHeight :number = 0;
  public dialogEditorPreference :boolean = false;
  public auth: Common.Auth = null;//new Common.Auth();
  public modal: Common.ModalLoader = new Common.ModalLoader();
  public formatter: Common.Formatter = new Common.Formatter(this);
  public perms: Common.PermissionControler = new Common.PermissionControler(this);
  public errorBinder = new Common.ModelBinder(Common.ErrorDetails);
  public sckeys: Common.ShortCutKey = new Common.ShortCutKey();
  public tooltip: Common.TooltipLoader = new Common.TooltipLoader();
  public functionFlag:number;
  public licenseFlag:number;
  public optionFlag:number;
  public license: Common.LicenseResult;
  public tenantVersion: Common.TenantVersions;
  public safeIntroductionPackExpiry: Date = null;
  public setRoadmapRatio:(roadmap : Common.UsageQueryResult)=>void;
  public clearRoadmapAlert:()=>void;
  public tenantSettings : any; //tenantネームスペースは回避する
  public systemCurrencyPrecision: number;
  public systemCurrencyRoundType: number;
  public currencies: Common.BindItem[] = [];
  public currencieMarks: Common.BindItem[] = [];
  public decimals:{[key:string]:number}= {};
  public campaigns:Common.Campaign[] = [];
  public get onlyOpen () {return localStorage['onlyOpen'] == 'true'};
  public customFunctionOpenFlag: boolean = false;
  public get fileMaxSizeMB() : number { return 4.4;}
  public get fileMaxSizeByte() : number { return 4.4 * 1024 * 1024;}
  
  public async initialize() {}
  public initialized : boolean = false;
  public initializeCallbacks = new Array<(value?:any)=>void>(); 
  public async waitInitialized(){
      return new Promise((resolve,reject) =>{
        this.initializeCallbacks.push(resolve);
      });
  }

  public handleMfaException(flag: Common.mfaFlags) {}

  public async authenticate() {

    //端末トークンの取得・更新=>bypassMfaの場合は端末トークンを取得しない(携帯ブラウザで取得済みの場合は送信される)
    if (this.bypassMfa == false) await this.multiFactorAuthenticate(new Common.MFACreateTokenQuery());

    //SMS認証解除トークンが指定されている場合は、解除処理を開始する
    if (location.search && location.search.indexOf('sms_reset') > -1){
      let params = new URLSearchParams(location.search);
      var token = params.get('sms_reset');
      await this.multiFactorAuthenticate(new Common.MFAValidateResetTokenQuery(token));
      return;
    }

    var timer = new Date();
    await this.auth.getToken();
    console.log(String.format('auth0 elapsed:= {0} ms',new Date().getTime() - timer.getTime()));
    timer = new Date();

    if (Api.siteMode == Common.siteModes.tenant || Api.siteMode == Common.siteModes.admin)
    {
      var license : Common.LicenseResult = await this.execute(new Common.LicenseQuery());
      this.license = license;
      this.auth.userName = license.user ? license.user.name : license.loginName;//license.loginNameから変更
      this.functionFlag = license.functionFlag;
      this.licenseFlag = license.licenseFlag;
      this.optionFlag = license.optionFlag;
      this.safeIntroductionPackExpiry = license.safeIntroductionPackExpiry;
      this.tenantVersion = license.tenantVersion;
      this.customFunctionOpenFlag = license.customFunctionOpenFlag;
      //ワークフローパーミッションの初期化
      this.perms.initialize(license);
    }
    if (Api.siteMode == Common.siteModes.tenant)
    {
      // パートナー設定の取得
      this.isPartner = await this.execute(new Common.isPartnerQuery());
    }

    console.log(String.format('auth1 elapsed:= {0} ms',new Date().getTime() - timer.getTime()));

    //ユーザーをロードする
    // var user = await this.execute(new Common.UserLoadQuery());
    // this.auth.userName = (user as Common.User).name;
    // this.licenseFlag = await this.execute(new Common.LicenseQuery());
  }

  public async loadCampaigns() {
    return this.execute(new Common.CampaignTenantQuery()).then(res => this.campaigns = res as Common.Campaign[]);
  }
  
  // 案件管理機能の利用
  public get useProjectItemFunction() : boolean
  {
    return (this.functionFlag & Common.functionFlags.ProjectItem ) != 0;
  }
  // 在庫管理機能の利用
  public get useStockFunction() : boolean
  {
    return (this.functionFlag & Common.functionFlags.Stock ) != 0;
  }
  // 運用管理機能の利用
  public get useOperationFunction() : boolean
  {
    return (this.functionFlag & Common.functionFlags.Operation ) != 0;
  }
  // 受発注管理機能の利用
  public get useSalesPurchaseOrderFunction() : boolean
  {
    return (this.functionFlag & Common.functionFlags.SalesPurchaseOrder ) != 0;
  }
  //サーバー専有フラグ
  public get isServerExclusive(): boolean 
  {
    return this.licenseFlag == Common.licenseFlags.prime || this.licenseFlag == Common.licenseFlags.prime2;
  }

  public readonly customFunctionFlags = customFunctionFlags;
  public customFunctionOpen(flag: customFunctionFlags): boolean
  {
    if(this.customFunctionOpenFlag) return true;
    return customFunctionFlagDefinitions[flag] ?? false;
  }

  /** テナントバージョンの確認、指定したバージョン以降かどうか確認します */
  public afterTenantVersion(version : Common.TenantVersions): boolean
  {
    return this.tenantVersion >= version;
  }
  /**ライセンスを確認します */
  public hasLicense(flag : Common.licenseFlags): boolean
  {
    return (this.licenseFlag & flag ) == flag; 
  }
  /**オプションプランを確認します */
  public hasOption(flag : number): boolean
  {
    // あんしん導入パック期間中は電話サポート有りとみなす
    if(flag == 1 && this.safeIntroductionPackExpiry >= new Date().getCalendarDate()) return true;
    return (this.optionFlag & flag) == flag; 
  }
  /**パートナーかどうかを確認します */
  public isPartner: boolean = false;

  /**環境を確認します */
  public get enviromentFlag():Common.enviromentFlags{
    if (process.env.VUE_APP_MODE == 'develop') return Common.enviromentFlags.develop;
    if (process.env.VUE_APP_MODE == 'staging') return Common.enviromentFlags.staging;
    return Common.enviromentFlags.production;
  }
  // handleRequestError(error: any): Promise<any> {
  //   this.modal.show('無効な操作', error, true, null);
  //   return Promise.reject(error);
  // }

  // handleResponseError(error: any): Promise<any> {
  //   if (error.response != null && error.response.status == 500) {
  //     const detail = this.errorBinder.loadInstance(error.response.data);
  //     this.modal.show('無効な操作', detail.message, true, null);
  //   } else if (error.response != null && error.response.status == 401) {
  //     this.modal.show('無効な操作', 'ユーザー認証に失敗しました。', true, null);
  //   } else if (error.response != null && error.request.responseType === 'blob' && error.response.data instanceof Blob && error.response.data.type && error.response.data.type.toLowerCase().indexOf('json') != -1) {
  //     //responseType=blobの場合は、error.responseもaxiosがblobに変換してしまうので、再解凍する
  //     return new Promise((resolve, reject) => {
  //       let reader = new FileReader();
  //       reader.onload = () => resolve(reader.result);
  //       reader.onerror = () => reject(error);
  //       reader.readAsText(error.response.data);
  //     }).then(resposne => {
  //       var json = JSON.parse(resposne as string);
  //       this.modal.show('無効な操作', json.message, true, null);
  //       return Promise.reject(error);
  //     });
  //   } else if (error.message) {
  //     this.modal.show('無効な操作', error.message, true, null);
  //   } else {
  //     this.modal.show('無効な操作', error.response.data, true, null);
  //   }

  //   return Promise.reject(error);
  // }

  // ****** ロケール ******




  // ****** ヘルパ関数 ******
  /**言語キーを元に設定されている単語を取得します */
  public getWord(key: string){
      // |で連結されたキーを変換
      if (key && key.indexOf("|") > -1){
        var results = new Array<string>();
        key.split('|').forEach(obj =>results.push(obj in words ? words[obj] : obj));
        return results.join('');
      } 
      //キーがある場合は変換し、ない場合はそのまま返す
      else if (key in words) return words[key];
      else return key; 
  }
  /**言語を変更してリロードします */
  public changeLang(lang: string) {
    localStorage.lang = lang;
    location.reload(true);
  }
  public async wordsReload()
  {
    await this.execute(new Common.UserWordQuery()).then(res=>(res as Common.BindItem[]).forEach((obj)=>words[obj.value]=obj.text));
  }

  public getLang() {
    if (localStorage.lang != null) return localStorage.lang;
    else return navigator.language; //未設定の場合は
  }

  private getConfig(token: string | void): AxiosRequestConfig {
    return {
      headers: { Authorization: 'Bearer ' + token, 'Accept-Language': this.getLang()},
      transformResponse: [
        function(data) {
          if (data) {
            try{
              const res = Common.Circular.retrocycle(JSON.parseWithDate(data));
              return res;
            }
            catch(e){
              return data;
            }

          } else {
            return null;
          }
        },
      ],
      transformRequest: this.transformRequest,
      // transformRequest: [
      //   (data, headers) => {
      //     headers.post['Content-Type'] = 'application/json';
      //     const obj = Common.Circular.decycle(data);
      //     const temp = JSON.stringify(obj, (_, v) =>
      //       !(v instanceof Array || v === null) && typeof v == 'object'
      //         ? Object.keys(v)
      //             .filter(item => item != 'binders' && item != 'className' && item != 'responseBinder')
      //             .sort()
      //             .reduce((r, k) => {
      //               (r as any)[k] = v[k];
      //               return r;
      //             }, {})
      //         : v
      //     );
      //     return temp;
      //   },
      // ],
      timeout: 29000,
    };
  }

  public transformRequest(data :any,headers:any) {
      headers.post['Content-Type'] = 'application/json';
      const obj = Common.Circular.decycle(data);
      const temp = JSON.stringify(obj, (_, v) =>
        !(v instanceof Array || v === null) && typeof v == 'object'
          ? Object.keys(v)
              .filter(item => item != 'binders' && item != 'className' && item != 'responseBinder' && item != '$id')
              // .sort() =>ソートすると循環参照の配置がくずれる
              .reduce((r, k) => {
                (r as any)[k] = v[k];
                return r;
              }, {$id:v['$id']})　//$idだけ手動で設定する
          : v
      );
      // console.log('json debug:=');      
      // console.log(temp);

      return temp;
  }

  public getNameSpace() {
    return (<any>Common);
  }
  
  public getReportNamespace():any{
    return null;
  }

  public createBinder(name: string, isCollection = false) {
    var obj = new Common.ModelBinder((this.getNameSpace())[name],isCollection);
    return obj;
  }

  public createInstance(name: string) {
    var obj = new (this.getNameSpace())[name]();
    return obj;
  }

  // ****** コンポーネントロード ******

  public launchDialog(component : VueConstructor<Vue>, router:VueRouter, propsData: any, target :Element){
    //利用状況照会ダイアログを開く
    let componentClass = Vue.extend(component);
    let instance = new componentClass({
        router,
        propsData:propsData,
      });
    instance.$mount();
    instance.$on('hidden', () => {
      //destroyできない
      instance.$el.parentElement.removeChild(instance.$el);
      instance.$destroy();
    });
    target.appendChild(instance.$el);    
  }

  public bypassMfa :boolean = false;//mfa認証を回避するためのフラグ

  // ****** クエリの実行 ******
  public async multiFactorAuthenticate(params: Common.Query): Promise<any> {
    return this.auth
      .getToken()
      .then(token => axios.post(Api.baseURL + '/multifactorauthenticate/' + params.className, params, this.getConfig(token)))
      .then(response => {  
        return Promise.resolve(params.responseBinder? params.responseBinder.loadInstance(response.data):response.data);
        // .catch(res => this.modal.show('無効な操作', res, true, null));
      });
  }

  /**サーバークエリを実行し結果を取得します。 */
  public async execute(params: Common.Query, enableEvent:boolean = false): Promise<any> {
    return this.auth
      .getToken()
      .then(token => axios.post(Api.baseURL + '/execute/' + params.className, params, this.getConfig(token)))
      .then(response => {  
        if (enableEvent) this.dispatchEvent('workflow');
        return Promise.resolve(params.responseBinder? params.responseBinder.loadInstance(response.data):response.data);
        // .catch(res => this.modal.show('無効な操作', res, true, null));
      });
  }
  
  // TenantReset用のbaseURLでクエリを実行します。
  public async tenantResetExecute(params: Common.Query, enableEvent:boolean = false): Promise<any> {
    return this.auth
      .getToken()
      .then(token => axios.post(Api.tenantResetBaseURL + '/multifactorauthenticate/' + params.className, params, this.getConfig(token)))
      // .then(response => {  
      //   if (enableEvent) this.dispatchEvent('workflow');
      //   return Promise.resolve(params.responseBinder? params.responseBinder.loadInstance(response.data):response.data);
      //   // .catch(res => this.modal.show('無効な操作', res, true, null));
      // });
  }

  //** リスト名を指定してマスタ(text/value)を取得します。 */
  public async list(listName: string): Promise<Common.BindItem[]> {
    const binder = new Common.ModelBinder(Common.BindItem2, true);
    return this.auth
      .getToken()
      .then(token => axios.post(Api.baseURL + '/list/' + listName, this.getConfig(token)))
      .then(response => {
        return Promise.resolve(binder.loadInstance(response.data));
      });
  }

  //** リスト名を指定してマスタ(text/value)を取得します。 */
  public async listAjax(listName: string, listKeys: any[], search: string = '', perPage:number = 1, targetPage:number = 1): Promise<Common.LoadResult> {
    const binder = new Common.GenericModelBinder(Common.LoadResult, Common.BindItem2);
    return this.auth
      .getToken()
      .then(token => axios.post(Api.baseURL + '/listAjax/' + listName, { listKeys: listKeys, search: search, perPage:perPage, targetPage:targetPage }, this.getConfig(token)))
      .then(response => {
        return Promise.resolve(binder.loadInstance(response.data));
      });
  }

  // ****** 単体オブジェクトの処理 ******

  public async add(obj: Common.ObjectBase): Promise<any> {
    const binder = obj.binder; //this.binders[obj.className];
    this.startWaitCusor();
    return this.auth
      .getToken()
      .then(token => axios.post(Api.baseURL + '/add/' + obj.className, obj, this.getConfig(token)))
      .then(response => {
        this.closeWaitCursor();
        this.dispatchEvent('workflow');
        return Promise.resolve(binder.loadInstance(response.data));
      });
  }

  public async update(obj: Common.ObjectBase): Promise<any> {
    const binder = obj.binder; //this.binders[obj.className];
    this.startWaitCusor();
    return this.auth
      .getToken()
      .then(token => axios.post(Api.baseURL + '/update/' + obj.className, obj, this.getConfig(token)))
      .then(response => {
        this.closeWaitCursor();
        this.dispatchEvent('workflow');        
        return Promise.resolve(binder.loadInstance(response.data));
      });
  }

  public async remove(obj: Common.ObjectBase): Promise<any> {
    this.startWaitCusor();
    return this.auth
      .getToken()
      .then(token => axios.post(Api.baseURL + '/remove/' + obj.className, obj, this.getConfig(token)))
      .then(response => {
        this.closeWaitCursor();
        this.dispatchEvent('workflow');        
        return Promise.resolve(response.data);
      });
  }

  public async send(obj: Common.ObjectBase, stateId: number, enableEvent:boolean = true): Promise<any> {
    const binder = obj.binder; //this.binders[obj.className];
    this.startWaitCusor();
    return this.auth
      .getToken()
      .then(token => axios.post(Api.baseURL + '/send/' + obj.className + '/' + stateId.toString(), obj, this.getConfig(token)))
      .then(response => {
        this.closeWaitCursor();
        if(enableEvent) this.dispatchEvent('workflow');
        return Promise.resolve(binder.loadInstance(response.data));
      });
  }

  public async sendBack(obj: Common.ObjectBase, enableEvent:boolean = true): Promise<any> {
    const binder = obj.binder; //this.binders[obj.className];
    this.startWaitCusor();
    return this.auth
      .getToken()
      .then(token => axios.post(Api.baseURL + '/sendback/' + obj.className, obj, this.getConfig(token)))
      .then(response => {
        this.closeWaitCursor();
        if(enableEvent) this.dispatchEvent('workflow');        
        return Promise.resolve(binder.loadInstance(response.data));
      });
  }

  //*** イベント実装 */
  public addEventListener(key:string,handler:()=>any){
    if (!this.eventListeners[key]) this.eventListeners[key] = new Array();
    this.eventListeners[key].push(handler);
  }
  public removeEventListener(key:string,handler:()=>any){
      if(this.eventListeners[key]) this.eventListeners[key] = this.eventListeners[key].filter(obj =>obj != handler);
  }
  public dispatchEvent(key:string)  {
     if(this.eventListeners[key]) this.eventListeners[key].forEach(handler=>handler());
  }
  public eventListeners :{[key:string]:Array<()=>any>} = {};



  //** キーを指定してオブジェクトをロードします */
  public async find(type: string, keys: any[]): Promise<any> {
    const binder = this.createBinder(type); //this.binders[type];
    return this.auth
      .getToken()
      .then(token => axios.post(Api.baseURL + '/find/' + type, keys, this.getConfig(token)))
      .then(response => {
        return Promise.resolve(binder.loadInstance(response.data));
      });
  }
  //リロード用に追加
  public async reload(obj: Common.ObjectBase): Promise<any> {
    const binder = obj.binder; //this.binders[obj.className];
    this.startWaitCusor();
    return this.auth
      .getToken()
      .then(token => axios.post(Api.baseURL + '/reload/' + obj.className, obj, this.getConfig(token)))
      .then(response => {
        this.closeWaitCursor();
        return Promise.resolve(binder.loadInstance(response.data));
      });
  }
  public async template(name: string): Promise<any> {
    const binder = new Common.ModelBinder(Common.CustomTemplate, false);
    return this.auth
      .getToken()
      .then(token => axios.post(Api.baseURL + '/template/' + name, '', this.getConfig(token)))
      .then(response => {
        return Promise.resolve(binder.loadInstance(response.data));
      });
  }

  // ****** ファイルアップロード・ダウンロード ******

  /**ファイルアップロード～inputタグのfilesをセットしてください */
  public async upload(params: Common.Query, files: FileList) {
    //FormDataにファイルをバインドする
    let formData = new FormData();
    for (var i = 0; i < files.length; i++) {
      let file = files[i]; //Formのパラメーター名はwebApi側一致させる必要がある。
      formData.append('files', file);
    }
    //クエリをJSON化して添付する
    formData.append('query', JSON.stringify2(Common.Circular.decycle(params)));
    //リクエスト結果をクエリでバインドする
    this.startWaitCusor();
    return this.auth
      .getToken()
      .then(token => axios.post(Api.baseURL + '/upload/' + params.className, formData, { headers: { Authorization: 'Bearer ' + token, 'Accept-Language': this.getLang(), 'Content-Type': 'multipart/form-data' } }))
      .then(response => {
        this.closeWaitCursor();
        return Promise.resolve(params.responseBinder?params.responseBinder.loadInstance(response.data):response.data);
      });
  }

  public async download(params: Common.Query) {
    this.startWaitCusor();
    return this.auth
      .getToken()
      .then(token => axios.post(Api.baseURL + '/download/' + params.className, params, { headers: { Authorization: 'Bearer ' + token, 'Accept-Language': this.getLang() }, responseType: 'blob', transformRequest:this.transformRequest }))
      .then(response => {
        this.closeWaitCursor();

         if (response.data.type == "application/json") {
           //JSONの処理
           return (response.data.text() as Promise<string>).then(json=>{
            var batch = JSON.parse(json);
            var links = [new Common.ModalLink(String.format('システムログ ID={0}',batch.batchLogId),String.format('/operation/SystemLog?id={0}',batch.batchLogId))];
            if(batch.isReport==true){
              this.modal.show('処理結果','帳票出力を開始しました。結果はメールでも通知されます。\r\n出力ファイルは、以下のリンクの添付ファイルタブから取得できます。',true,null,links);    
            }
            else{
              this.modal.show('処理結果','エクスポート件数が1000件を越えたためバッチ処理が開始されました。結果はメールでも通知されます。\r\n出力ファイルは、以下のリンクの添付ファイルタブから取得できます。',true,null,links);       
            }
            return;               
           });
         }

        //ファイル名の解凍
        var regex = /(?:filename\*=UTF-8'')(.*)/; //RFC 6266
        var matches = regex.exec(response.headers['content-disposition']);
        var filename = decodeURI(matches[1]);

        if (response.headers['content-disposition'].startsWith('inline')) {
          //ブラウザオープン
          const url = URL.createObjectURL(new Blob([response.data], { type: response.data.type }));
          this.sckeys.enabled = false;
          var win = window.open(url);
          win.onload = ()=> {
            setTimeout(function(){
                win.document.getElementsByTagName('html')[0]
                  .appendChild(document.createElement('head'))
                  .appendChild(document.createElement('title'))
                  .appendChild(document.createTextNode(filename));
              },200)};
          this.sckeys.enabled = true;
        } else {
          //ダウンロード


          const url = URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          link.click();
          URL.revokeObjectURL(url);
        }
      });
  }
  public async fileDownload(fileUrl: string) {
          const link = document.createElement('a');
          link.href = fileUrl;
          link.setAttribute('download', 'file_download');
          link.click();
          URL.revokeObjectURL(fileUrl);
  }

  public async removeFiles(files: Common.UploadFile[]) {
    this.startWaitCusor();
    return this.auth
      .getToken()
      .then(token => axios.post(Api.baseURL + '/removeFile', files, { headers: { Authorization: 'Bearer ' + token, 'Accept-Language': this.getLang() } }))
      .then(response => {
        this.closeWaitCursor();
        return Promise.resolve(response.data);
      });
  }

  // ****** 更新時のWait Cursor ******

  spinner: HTMLElement;
  waitCount: number = 0;

  public startWaitCusor() {
    if (this.waitCount == 0) {
      this.spinner = document.createElement('div');
      this.spinner.className = 'spinner';
      this.spinner.style.cursor = 'wait';
      this.spinner.style.opacity = '0.2';
      this.spinner.style.zIndex = '1999';
      this.spinner.id="spinner";
      // this.spinner.style.pointerEvents = 'none';
      document.body.appendChild(this.spinner);
    }
    this.waitCount++;
  }

  public closeWaitCursor(reset = false) {
    if (this.waitCount > 1 && reset == false) {
      this.waitCount--;
    } else {
      this.waitCount = 0;
      if (this.spinner) {
        document.body.removeChild(this.spinner);
        this.spinner = null;
      }
    }
  }

  public updateRoadmapRatio(){
      this.execute(new Common.UsageQuery(Common.UsageCountType.Default)).then(obj=>{
            this.setRoadmapRatio((obj as Common.UsageQueryResult));  
      });
  }

  public getMaxZIndex() {
    //cx_layerもしくはBootStrap.vueモーダルの非活性レイヤで表示されているものを検索する。

    //cx_layer
    var maxLayer =  Array.from(document.body.querySelectorAll('div.cx_layer'))
      .filter(el =>  (el as HTMLElement).style.display != 'none')
      .reduce((max, el) => Math.max(max, parseInt((el as HTMLElement).style.zIndex, 10)), 0);
    
    //Bootstrap.vueのモーダル(elementに指定されていない場合がある)
    var maxModal =  Array.from(document.body.querySelectorAll('div.modal'))
      .filter(el => (el as HTMLElement).style.display != 'none')
      .reduce((max, el) => Math.max(max, parseInt(window.getComputedStyle(el).zIndex, 10)), 0);

    return Math.max(maxLayer,maxModal);
  }

  public async getAddress(postalCode : string){
    //使用量の計測
    // var dataLayer = (window as any).dataLayer;
    // if(dataLayer)dataLayer.push({'event': 'dialog', 'message':'PostalcodeJP'});             
    this.issueGA4eventCommon({'event': 'dialog', 'message':'PostalcodeJP'}) ;
    return axios.get('https://apis.postcode-jp.com/api/v5/postcodes/' + postalCode.replace('-','') , { headers: { apiKey: 'TOY9PMNJHBiTaUsqBopzWja1Pol9G3xadXxJz9l'}})
    .then(res =>(res as any).data[0].allAddress).catch(error =>'');
  }

  public issueGA4event(path:string, eventName: string){
    this.issueGA4eventCommon({'event':'appevent', 'appevent':eventName,'path':path,});
  }

  public issueGA4trackevent(path:string, eventName: string){
   this.issueGA4eventCommon({'event':'apptrack', 'appevent':eventName,'path':path,});
 }

  public issueGA4eventCommon(event : any){
    //tenantId
    if (!event.tenantId){
      if (process.env.NODE_ENV == 'production') event.tenantId = window.location.host.split('.')[0];      
      else event.tenantId =process.env.VUE_APP_SUBDOMAIN;    
    }
    //path(未指定の場合)
    if (!event.path) event.path = location.pathname; //
    //contract
    if(this.license) event.contract = this.license.isTrial ? 'トライアル':'有償利用';
    //earlyTrialStage
    event.earlyTrialStage = this.earlyTrialStage ? 'true' : 'false';
    //有償開始ユーザー
    if(this.license) event.paidEntryUser = this.license.paidEntryUser ? 'true':'false';
    //ログ
    // console.log(event);
    //イベント発行
    var dataLayer = (window as any).dataLayer;
    if(dataLayer)dataLayer.push(event); 
  }

  public earlyTrialStage :boolean = false;
}

const plugin = {
  install() {
    const api = Vue.observable(new Api()); //リアクティブ対応(監視可能)
    //   フォーマッタの注入
    Object.defineProperty(Vue.prototype, '$api', {
      get() {
        return api;
      },
    });
  },
};

export default plugin;
